/* eslint-disable @next/next/no-img-element */
import { useEffect, useRef, useState } from "react"
import { HoverSkew } from "../HoverSkew"
import { Heading, LargeHeading, Paragraph, Section } from "../misc"
import Hero from "public/marketing/code-snippet-2.svg"

export const CodeSnippet = () => {
  return (
    <Section className="text-center">
      <HoverSkew glowStength="light" className="md:px-10 px-7 md:py-8 py-6 lg:px-16 lg:py-10">
        <div className="flex flex-col lg:flex-row gap-2 lg:gap-10 justify-center items-stretch">
          <div className="flex flex-col items-start justify-center py-0 text-left">
            <Heading>Integrate in minutes</Heading>
            <Paragraph className="text-left">
              Setup takes minutes. Build paywalls, deploy A/B tests, add logic — all remotely from{" "}
              {"Superwall's"} dashboard.
            </Paragraph>
          </div>
          <div className="hidden lg:block w-[1px] mr-4 bg-white bg-opacity-5"></div>
          {/* <div className="hidden sm:block lg:hidden h-[1px] my-3 bg-white bg-opacity-5"></div> */}
          <div className="flex py-3 sm:pt-4 flex-col items-start justify-center lg:py-5">
            <img className="border-none" src={Hero.src} alt="dashboard-header"></img>
          </div>
        </div>
      </HoverSkew>
    </Section>
  )
}
